import { render, staticRenderFns } from "./billedVsRealPivot.vue?vue&type=template&id=4b05f063&scoped=true"
import script from "./billedVsRealPivot.vue?vue&type=script&lang=js"
export * from "./billedVsRealPivot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05f063",
  null
  
)

export default component.exports